module.exports = __webpack_public_path__ + "static/media/wapp.45c1cb0e.svg";